<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="header">Salary and Fund Values</div>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label>Current Value of Retirement Funds </label>
          <div class="ui labeled input">
            <currency-input
              v-model="raInputsDto.currentValueOfPensionFunds"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label
            >Current Annual Salary (gross of tax)
            <small
              >(R {{ formatNr(raInputsDto.currentSalary / 12) }} pm)</small
            ></label
          >
          <div class="ui labeled input">
            <currency-input
              v-model="raInputsDto.currentSalary"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label>Salary growth rate <small>(% )</small></label>
          <div class="ui right labeled input">
            <input
              v-model="raInputsDto.salaryGrowthRate"
              v-on:change="handleSelected"
            />
            <div class="ui label">%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui attached message">
      <strong>Contributions</strong>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label
            >Contribution (% of Salary)
            <small
              >(R{{
                formatNr(
                  (raInputsDto.contributionPercentage / 1200) *
                    raInputsDto.currentSalary,
                  "0,0.0a"
                )
              }}
              pm)</small
            ></label
          >
          <div class="ui right labeled input">
            <input
              v-model="raInputsDto.contributionPercentage"
              v-on:change="handleSelected"
            />
            <div class="ui label">%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui attached message">
      <strong>Bonus </strong>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label>Annual Bonus <small>(as a % of Salary)</small></label>
          <div class="ui right labeled input">
            <input
              v-model="raInputsDto.annualBonusAsAPercentageOfSalary"
              v-on:change="handleSelected"
            />
            <div class="ui label">%</div>
          </div>
        </div>
        <div class="ui field">
          <strong>Bonus Savings Strategy</strong
          ><a href="#" @click.prevent="showBonusStrategy = true"
            ><i class="ui question circle outline icon"></i>
          </a>
          <div class="ui mini toggle checkbox" style="font-size: 10px;">
            <input
              type="checkbox"
              @change="handleSelected"
              v-model="raInputsDto.contributeAnnualBonus"
            />
            <label>{{
              !raInputsDto.contributeAnnualBonus ? "Disabled" : "Enabled"
            }}</label>
          </div>
        </div>
        <div class="ui field" v-if="raInputsDto.contributeAnnualBonus">
          <label
            >Bonus Contribution to Retirement Fund <small>(%) </small>
            <a href="#" @click.prevent="showBonusStrategy = true"
              ><i class="ui question circle outline icon"></i> </a
          ></label>
          <div class="ui right labeled input">
            <input
              v-model="raInputsDto.annualBonusContributionPercentToRa"
              v-on:change="handleSelected"
            />
            <div class="ui label">%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui attached message">
      <div class="header">Retirement Goals</div>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label>Retirement Age</label>
          <div class="ui  input">
            <input
              v-model="raInputsDto.retirementAge"
              v-on:change="handleSelected"
            />
          </div>
        </div>
        <div class="ui field">
          <label>Income needed as % of final salary</label>
          <div class="ui right labeled input">
            <input
              v-model="raInputsDto.incomeNeeds.target"
              v-on:change="handleSelected"
            />
            <div class="ui label">%</div>
          </div>
        </div>
      </div>
    </div>

    <sui-modal v-model="showBonusStrategy">
      <sui-modal-header>What is the Bonus Strategy?</sui-modal-header>
      <sui-modal-content>
        <sui-modal-description>
          <div class="ui message">
            <strong>The bonus strategy </strong> can bring a significant boost
            to meeting your retirement targets. This savings strategy involves
            contributing a given % of your bonus towards your retirement funds
            every year. For example, if you earn a 13th cheque as a bonus,
            setting aside a portion of that bonus towards your retirement can
            have a significant impact on ensuring you meet your retirement
            goals.
            <br />
            <br />

            <span v-if="raInputsDto.contributeAnnualBonus"
              ><span class="highlight">
                In your case, you have activated the bonus strategy</span
              >. Specifically,
              <span class="highlight">
                {{
                  formatNr(
                    raInputsDto.annualBonusContributionPercentToRa / 100,
                    "0,0.0%"
                  )
                }}
                of your annual bonus</span
              >
              will be contributed towards your retirement funds. This is in
              addition to your monthly contributions from your salary.<br /><br />
              To illustrate, given an annual bonus of R{{
                formatNr(
                  (raInputsDto.annualBonusAsAPercentageOfSalary / 100) *
                    raInputsDto.currentSalary,
                  "0,0.0a"
                )
              }}
              - which is
              {{
                formatNr(
                  raInputsDto.annualBonusAsAPercentageOfSalary / 100,
                  "0,0.0%"
                )
              }}
              of your current annual salary - and contributing
              {{
                formatNr(
                  raInputsDto.annualBonusContributionPercentToRa / 100,
                  "0,0.0%"
                )
              }}
              (ie R{{
                formatNr(
                  (raInputsDto.annualBonusAsAPercentageOfSalary / 100) *
                    (raInputsDto.annualBonusContributionPercentToRa / 100) *
                    raInputsDto.currentSalary,
                  "0,0.0a"
                )
              }}) of your bonus towards the retirement fund, you will increase
              your chances of meeting your retirement goals further compared to
              merely contributing a given percentage from your salary.
            </span>
            <span v-else style="">
              <span class="highlight"
                >In your case, the bonus savings strategy is deactivated</span
              >
              . Given that an annual bonus is expected - equivalent to
              {{
                formatNr(
                  raInputsDto.annualBonusAsAPercentageOfSalary / 100,
                  "0,0.0%"
                )
              }}
              of your salary - it is worthwhile considering to contribute part
              of this bonus towards a retirement fund. This has the impact of
              further reducing your tax and increasing the likelihood of meeting
              your retirement goals.
            </span>
          </div>
        </sui-modal-description>
      </sui-modal-content>

      <sui-modal-actions>
        <sui-button @click.native="showBonusStrategy = false">Close</sui-button>
      </sui-modal-actions>
    </sui-modal>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
export default {
  name: "Testing",
  props: ["raInputsDto"],
  data() {
    return {
      showBonusStrategy: false,
    };
  },
  computed: {
    partnerId() {
      return this.$store.state.partnerId;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0a");
    },
    async handleSelected(selected) {
      this.$emit("handleWrapperInputsChanged", {
        raInputsDto: this.raInputsDto,
      });
    },

    async init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}

.highlight {
  font-weight: bold;
}
</style>
